import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, resolveDirective as _resolveDirective, vModelRadio as _vModelRadio, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"content-header\"><div class=\"container-fluid\"><div class=\"row mb-2\"><div class=\"col-sm-6\"><h1>Inventário</h1></div><div class=\"col-sm-6\"><ol class=\"breadcrumb float-sm-right\"><li class=\"breadcrumb-item\"><a href=\"#\">Home</a></li><li class=\"breadcrumb-item active\">Inventário</li></ol></div></div></div></section>", 1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "row filter-box" }
const _hoisted_4 = { class: "form-group col-sm-12 col-md-4 col-lg-2 col-xl-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Cidade", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Todos", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-group col-sm-12 col-md-4 col-lg-3 col-xl-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Grupo de carros", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Todos", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "form-group col-sm-12 col-md-4 col-lg-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Período", -1)
const _hoisted_14 = { class: "form-group col-sm-12 col-md-12 col-lg-4 col-xl-5" }
const _hoisted_15 = { class: "slot-table" }
const _hoisted_16 = { class: "slot-day" }
const _hoisted_17 = {
  rowspan: "2",
  class: "slot-day-td"
}
const _hoisted_18 = { class: "lb-day" }
const _hoisted_19 = { class: "lb-day-week" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "slot-time slot-time-a" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock" }),
  /*#__PURE__*/_createTextVNode(" 360s ")
], -1)
const _hoisted_21 = { class: "slot-detail" }
const _hoisted_22 = { class: "slot-detail-content" }
const _hoisted_23 = { class: "slot-detail-content-body" }
const _hoisted_24 = { class: "slot-detail-content-dt" }
const _hoisted_25 = { class: "slot-detail-footer slot-detail-footer-1" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "slot-time slot-time-b" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock" }),
  /*#__PURE__*/_createTextVNode(" 360s ")
], -1)
const _hoisted_27 = { class: "slot-detail" }
const _hoisted_28 = { class: "slot-detail-content" }
const _hoisted_29 = { class: "slot-detail-content-body" }
const _hoisted_30 = { class: "slot-detail-content-dt" }
const _hoisted_31 = { class: "slot-detail-footer slot-detail-footer-2" }
const _hoisted_32 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block","padding-right":"15px"}
}
const _hoisted_33 = { class: "modal-dialog modal-lg" }
const _hoisted_34 = { class: "modal-content" }
const _hoisted_35 = { class: "modal-header" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h4", { class: "modal-title" }, "Novo Pedido", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "modal-body row" }
const _hoisted_40 = { class: "form-group col-12 col-lg-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "city" }, [
  /*#__PURE__*/_createTextVNode("Praça "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "form-group col-12 col-lg-6" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "duration" }, [
  /*#__PURE__*/_createTextVNode("Duração (segundos) "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_45 = { class: "form-group col-12 col-lg-6" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "period_start" }, [
  /*#__PURE__*/_createTextVNode("Início "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_47 = { class: "form-group col-12 col-lg-6" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "period_end" }, [
  /*#__PURE__*/_createTextVNode("Fim "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_49 = { class: "form-group col-12 col-lg-6" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { for: "economic_sector" }, [
  /*#__PURE__*/_createTextVNode("Segmento "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "form-group col-12 col-lg-6" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { for: "exclusive" }, [
  /*#__PURE__*/_createTextVNode("Exclusivo "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_54 = { class: "form-group col-12 col-lg-6" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { for: "product_type" }, [
  /*#__PURE__*/_createTextVNode("Área "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "form-group col-12 col-lg-6" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { for: "quantity_cars" }, [
  /*#__PURE__*/_createTextVNode("Quantidade de carros "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_59 = { class: "form-group clearfix" }
const _hoisted_60 = { class: "icheck-success" }
const _hoisted_61 = ["id", "value"]
const _hoisted_62 = ["for"]
const _hoisted_63 = { class: "form-group col-12" }
const _hoisted_64 = {
  key: 0,
  class: "form-group col-12 box-group"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", {
  class: "row card-grid",
  style: {"margin":"0"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-2 card box card-block",
    style: {"background-color":"lavender"}
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-5 card box card-block",
    style: {"background-color":"lavender","text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("b", null, "Grupo de Carros")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-5 card box card-block",
    style: {"background-color":"lavender","text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("b", null, "Descrição")
  ])
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-2 text-center",
  style: {"margin-bottom":"3px"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "far fa-check-square text-success",
    disabled: ""
  })
], -1)
const _hoisted_67 = {
  class: "col-5 text-center",
  style: {"margin-bottom":"3px"}
}
const _hoisted_68 = {
  class: "col-5 text-center",
  style: {"margin-bottom":"3px"}
}
const _hoisted_69 = { class: "row" }
const _hoisted_70 = {
  class: "form-group col-12",
  style: {"margin-bottom":"10px"}
}
const _hoisted_71 = {
  key: 1,
  class: "form-group col-12 box-group"
}
const _hoisted_72 = /*#__PURE__*/_createStaticVNode("<div class=\"row card-grid\" style=\"margin:0;\"><div class=\"col-4 card box card-block\" style=\"background-color:lavender;text-align:center;\"><b>Praça</b></div><div class=\"col-2 card box card-block\" style=\"background-color:lavender;text-align:center;\"><b>Duração</b></div><div class=\"col-2 card box card-block\" style=\"background-color:lavender;text-align:center;\"><b>Qtd Carros</b></div><div class=\"col-4 card box card-block\" style=\"background-color:lavender;text-align:center;\"><b>Grupo</b></div></div>", 1)
const _hoisted_73 = {
  class: "col-md-4 text-center",
  style: {"margin-bottom":"3px"}
}
const _hoisted_74 = {
  class: "col-md-2 text-center",
  style: {"margin-bottom":"3px"}
}
const _hoisted_75 = {
  class: "col-md-2 text-center",
  style: {"margin-bottom":"3px"}
}
const _hoisted_76 = {
  class: "col-4 text-center",
  style: {"margin-bottom":"3px"}
}
const _hoisted_77 = { class: "modal-footer justify-content-between" }

export function render(_ctx, _cache) {
  const _component_Datepicker = _resolveComponent("Datepicker")
  const _component_Toggle = _resolveComponent("Toggle")
  const _directive_maska = _resolveDirective("maska")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("select", {
            id: "city",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.filterSlot.city) = $event)),
            style: {"width":"100%","max-width":"-webkit-fill-available"},
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors_filter.city }])
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cities, (i, k) => {
              return (_openBlock(), _createElementBlock("option", {
                value: i.id,
                key: k
              }, _toDisplayString(i.description), 9, _hoisted_7))
            }), 128))
          ], 2), [
            [_vModelSelect, _ctx.filterSlot.city]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("select", {
            id: "carGroup",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.filterSlot.carGroup) = $event)),
            style: {"width":"100%","max-width":"-webkit-fill-available"},
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors_filter.carGroup }])
          }, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.car_groups, (i, k) => {
              return (_openBlock(), _createElementBlock("option", {
                value: i.id,
                key: k
              }, _toDisplayString(i.description), 9, _hoisted_11))
            }), 128))
          ], 2), [
            [_vModelSelect, _ctx.filterSlot.carGroup]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_Datepicker, {
            modelValue: _ctx.filterSlot.period,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.filterSlot.period) = $event)),
            format: _ctx.formatDatePreview,
            enableTimePicker: false,
            range: "",
            maxRange: _ctx.maxRangePeriod,
            autoApply: ""
          }, null, 8, ["modelValue", "format", "maxRange"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            type: "button",
            class: "btn bt-filter",
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.doFilter()))
          }, "Filtrar"),
          _createElementVNode("button", {
            type: "button",
            class: "btn bt-new",
            onClick: _cache[4] || (_cache[4] = $event => (_ctx.newOrder()))
          }, "Novo Pedido")
        ])
      ]),
      _createElementVNode("table", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dates, (date, k) => {
          return (_openBlock(), _createElementBlock("span", {
            key: k,
            class: "slot-span"
          }, [
            _createElementVNode("tr", _hoisted_16, [
              _createElementVNode("td", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(date.day), 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(date.day_week), 1)
              ]),
              _hoisted_20,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order_slots_main[date.date], (slot, k) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: k,
                  class: _normalizeClass(["slot", { 'slot-start-1': slot?.start }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slot?.items, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: _normalizeClass(["slot-sold slot-sold-1", { 'slot-sold-start': item.start, 'slot-sold-end': item.end, 'slot-sold-middle': item.middle }]),
                      style: _normalizeStyle([ item.middle ? {} : { width: item.size + 'px' }])
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", null, _toDisplayString(item?.data?.campaign), 1),
                          _createElementVNode("div", _hoisted_23, _toDisplayString(item?.data?.company_name), 1),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(item?.data?.start) + " - " + _toDisplayString(item?.data?.end), 1)
                        ]),
                        _createElementVNode("div", _hoisted_25, " Anúncio - " + _toDisplayString(item?.data?.time) + "s ", 1)
                      ])
                    ], 6))
                  }), 128))
                ], 2))
              }), 128))
            ]),
            _createElementVNode("tr", null, [
              _hoisted_26,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order_slots_inf[date.date], (slot, k) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: k,
                  class: _normalizeClass(["slot", { 'slot-start-2': slot?.start }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slot?.items, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: _normalizeClass(["slot-sold slot-sold-2", { 'slot-sold-start': item.start, 'slot-sold-end': item.end, 'slot-sold-middle': item.middle }]),
                      style: _normalizeStyle([ item.middle ? {} : { width: item.size + 'px' }])
                    }, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", null, _toDisplayString(item?.data?.campaign), 1),
                          _createElementVNode("div", _hoisted_29, _toDisplayString(item?.data?.company_name), 1),
                          _createElementVNode("div", _hoisted_30, _toDisplayString(item?.data?.start) + " - " + _toDisplayString(item?.data?.end), 1)
                        ]),
                        _createElementVNode("div", _hoisted_31, " Anúncio - " + _toDisplayString(item?.data?.time) + "s ", 1)
                      ])
                    ], 6))
                  }), 128))
                ], 2))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    (_ctx.showNewOrder)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  "aria-label": "Fechar",
                  onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_38)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _withDirectives(_createElementVNode("select", {
                    id: "city",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.row.city) = $event)),
                    style: {"width":"100%","max-width":"-webkit-fill-available"},
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.city }]),
                    onChange: _cache[7] || (_cache[7] = $event => (_ctx.selectCity()))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cities, (i, k) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: i.id,
                        key: k
                      }, _toDisplayString(i.description), 9, _hoisted_42))
                    }), 128))
                  ], 34), [
                    [_vModelSelect, _ctx.row.city]
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _withDirectives(_createElementVNode("input", {
                    id: "duration",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.row.duration) = $event)),
                    type: "text",
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.duration }]),
                    style: {"width":"100%","max-width":"-webkit-fill-available"}
                  }, null, 2), [
                    [_vModelText, _ctx.row.duration],
                    [_directive_maska, '####']
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createVNode(_component_Datepicker, {
                    id: "period_start",
                    modelValue: _ctx.row.period_start,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.row.period_start) = $event)),
                    format: _ctx.formatDateSimplePreview,
                    enableTimePicker: false,
                    autoApply: "",
                    class: _normalizeClass({ 'is-invalid': _ctx.errors.period_start })
                  }, null, 8, ["modelValue", "format", "class"])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createVNode(_component_Datepicker, {
                    id: "period_end",
                    modelValue: _ctx.row.period_end,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.row.period_end) = $event)),
                    format: _ctx.formatDateSimplePreview,
                    enableTimePicker: false,
                    autoApply: "",
                    class: _normalizeClass({ 'is-invalid': _ctx.errors.period_end })
                  }, null, 8, ["modelValue", "format", "class"])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _withDirectives(_createElementVNode("select", {
                    id: "economic_sector",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.row.economic_sector) = $event)),
                    style: {"width":"100%","max-width":"-webkit-fill-available"},
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.economic_sector }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.economic_sectors, (i, k) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: i.id,
                        key: k
                      }, _toDisplayString(i.description), 9, _hoisted_51))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, _ctx.row.economic_sector]
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createVNode(_component_Toggle, {
                    modelValue: _ctx.row.exclusive,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.row.exclusive) = $event)),
                    "on-label": "Sim",
                    "off-label": "Não",
                    class: "toggle-enabled-60px",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _hoisted_55,
                  _withDirectives(_createElementVNode("select", {
                    id: "product_type",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.row.product_type) = $event)),
                    style: {"width":"100%","max-width":"-webkit-fill-available"},
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.product_type }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product_types, (i, k) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: i.id,
                        key: k
                      }, _toDisplayString(i.description), 9, _hoisted_56))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, _ctx.row.product_type]
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _hoisted_58,
                  _createElementVNode("div", _hoisted_59, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.car_groups_city, (i, k) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "quantity_cars",
                          id: 'quantity_cars_' + k,
                          value: i.description,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.row.quantity_cars) = $event))
                        }, null, 8, _hoisted_61), [
                          [_vModelRadio, _ctx.row.quantity_cars]
                        ]),
                        _createElementVNode("label", {
                          for: 'quantity_cars_' + k,
                          style: {"font-weight":"400"}
                        }, _toDisplayString(i.description) + "    ", 9, _hoisted_62)
                      ]))
                    }), 256))
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm bt-filter",
                    style: {"margin":"0","float":"right","width":"auto"},
                    onClick: _cache[15] || (_cache[15] = $event => (_ctx.doFilterSlotsToSelect()))
                  }, "Filtrar")
                ]),
                (_ctx.showSlotsToSelect)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _hoisted_65,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carGroupsSelected, (group, k) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "row box-row",
                          key: k
                        }, [
                          _hoisted_66,
                          _createElementVNode("div", _hoisted_67, _toDisplayString(group.name), 1),
                          _createElementVNode("div", _hoisted_68, _toDisplayString(group.description), 1)
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-success",
                            style: {"margin":"0 10px","float":"right","width":"auto"},
                            onClick: _cache[16] || (_cache[16] = $event => (_ctx.addGroupsToOrder()))
                          }, "Adicionar")
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.groupsToInsert.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                      _hoisted_72,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupsToInsert, (group, k) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "row box-row",
                          key: k
                        }, [
                          _createElementVNode("div", _hoisted_73, _toDisplayString(group.city_desc), 1),
                          _createElementVNode("div", _hoisted_74, _toDisplayString(group.duration) + "\" ", 1),
                          _createElementVNode("div", _hoisted_75, _toDisplayString(group.quantity_cars), 1),
                          _createElementVNode("div", _hoisted_76, _toDisplayString(group.car_groups_selected_desc), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-default",
                  onClick: _cache[17] || (_cache[17] = (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, "Fechar"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-primary",
                  onClick: _cache[18] || (_cache[18] = (...args) => (_ctx.newOrderNextStep && _ctx.newOrderNextStep(...args)))
                }, "Avançar")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}